import { isValid, parseISO } from 'date-fns'

import { convertUTCToISO8601format } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/convertUTCToISO8601format'

/**
 * Parses an LT outcome response date as a UTC instant.
 *
 * LT can return ISO timestamps without an offset. The shared converter intentionally treats those
 * values as UTC, keeping selector ordering and every rendered outcome date consistent.
 */
export const parseOutcomeResponseDate = (responseDate?: string | null): Date | undefined => {
  if (!responseDate) return undefined

  const parsedDate = parseISO(convertUTCToISO8601format(responseDate))
  return isValid(parsedDate) ? parsedDate : undefined
}

/**
 * Calendar-day identity for the provider's local timezone.
 *
 * The assessment tables render outcome dates in the browser's timezone. Building the key from
 * local date parts keeps grouping aligned with that display, including UTC instants that fall on
 * the previous local day.
 */
export const getLocalDateKey = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getOutcomeLocalDateKey = (responseDate?: string | null): string | undefined => {
  const parsedDate = parseOutcomeResponseDate(responseDate)
  return parsedDate ? getLocalDateKey(parsedDate) : undefined
}
